module.exports = __webpack_public_path__ + "static/media/Godawan_thumb.d33cc7ca.jpg";